// BlogSection.js - Estatica Skin and Laser
import React, { useEffect, useState ,useContext} from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/customer/screens/blogScreen/AllBlog.css";
import EsBlogCard from "../../../components/customer/blog/EsBlogCard";
import AppContext from "../../../context/AppContext";
import axios from "axios";

// const blogs = [
//   {
//     id: 1,
//     date: "May 02, 2026",
//     readTime: "4 min read",
//     title: "5 Skincare Basics Every Patient Should Follow",
//     excerpt:
//       "Cleanse, treat, hydrate, protect — the routine our dermatologists recommend.",
//     image:
//       "https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=600&q=80",
//   },
//   {
//     id: 2,
//     date: "Apr 21, 2026",
//     readTime: "5 min read",
//     title: "Is Laser Hair Removal Safe? What to Expect",
//     excerpt:
//       "A clear, dermatologist-backed look at how modern laser systems work.",
//     image:
//       "https://images.unsplash.com/photo-1609840114035-3c981b782dfe?w=600&q=80",
//   },
//   {
//     id: 3,
//     date: "Apr 10, 2026",
//     readTime: "3 min read",
//     title: "Hydration: The Most Underrated Glow Hack",
//     excerpt:
//       "Why drinking water and using the right humectants changes your skin.",
//     image:
//       "https://images.unsplash.com/photo-1547592180-85f173990554?w=600&q=80",
//   },
// ];
const AllBlogs = ({screen}) => {
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFile } = useContext(AppContext);
  const [blogs, setBlogs] = useState([]);

const viewAllBlogs = () => {
  axios
    .get(`${baseUrl}/admin/blog/viewAllBlogs`)
    .then((response) => {
      console.log(response.data);
       if(screen == "blog")
        {
          setBlogs(response.data.slice(0,3));
        }else{
          setBlogs(response.data);
        }
      setBlogs(response.data); 
    })
    .catch((error) => {
      console.log(error);
    });
};

     useEffect(() => {
        viewAllBlogs();
      }, []);

  return (
    <section className="estatica-blog">
      <Container>
        {/* Heading */}
        <Row>
          <Col lg={8} md={10}>
            <p className="estatica-blog__label">Blog</p>
            <h2 className="estatica-blog__heading">
              Skin care &amp; laser insights.
            </h2>
          </Col>
        </Row>

        {/* Blog Cards */}
        <Row>
          {blogs.map((blog) => (
            <EsBlogCard blog={blog}/>
            // <Col lg={4} md={4} sm={12} key={blog.id}>
            //   <div className="estatica-blog__card">
            //     {/* Image */}
            //     <div className="estatica-blog__img-wrapper">
            //       <img src={blog.image} alt={blog.title} />
            //     </div>

            //     {/* Meta */}
            //     <p className="estatica-blog__meta">
            //       {blog.date} &nbsp;·&nbsp; {blog.readTime}
            //     </p>

            //     {/* Title */}
            //     <h4 className="estatica-blog__title">{blog.title}</h4>

            //     {/* Excerpt */}
            //     <p className="estatica-blog__excerpt">{blog.excerpt}</p>
            //   </div>
            // </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default AllBlogs;